import { ShopService } from './../../../../../services/shop.service';
import {Component, OnInit} from '@angular/core';
import Swal from "sweetalert2";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import * as XLSX from "xlsx";
import {DatePipe} from "@angular/common";
import { Observable } from 'rxjs';
import { Param } from '../../../../../models/param.model';
import { environment } from '../../../../../environments/environment';
import { IShop, Shop } from '../../../../../models/shop.model';
import { EncryptionService } from '../../../../../services/EncryptionService';
import { SharedFonctionsService } from '../../../../../services/shared-fonctions.service';
@Component({
  selector: 'app-list-shop',
  templateUrl: './list-shop.component.html',
  styleUrls: ['./list-shop.component.scss']
})
export class ListShopComponent implements OnInit {

  shops: Shop[] = [];
  shopTampons: Shop[] = [];
  initialShops: Shop[] = [];
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems :any;
  imageName: string | undefined = '';
  nbTotalPurchase: number = 0;
  url_photo: String;
  selected: boolean = false;
  unitTime: string [] = [];
  isHighlighted$: Observable<boolean>;
  search: any;
  // @ts-ignore
  public modalRef: BsModalRef;
  highlightedPosts:any[] = [];
  param: Param;
  constructor(private fb: FormBuilder, private sharedSevice: SharedFonctionsService,
              private router: Router, private encryptionService: EncryptionService,
              private shopService: ShopService, private datePipe: DatePipe) {
    this.unitTime = ['Minutes', 'Heurs', 'Jours', 'Mois'];
  }

  ngOnInit(): void {
    this.allKahpooShop();
    this.url_photo = environment.url_photo;
  }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  allKahpooShop() {
    this.shopService.getAllShop(this.pageNumber-1, this.pageSize).subscribe(data => {
      this.shops = data.content;
      this.totalItems = data.totalElements;
      this.initialShops = this.shops;
      this.shopTampons = this.shops;
      // console.log("Liste des boutique crée sur Kahpoo ...")
      // console.log(this.shops)
    })
  }

  shopDetailsDislayed : Shop;
  shopDetails(shop: Shop) {
    this.shopDetailsDislayed = shop;
    // console.log("Affichage des détails de la boutique");
    // console.log(this.shopDetailsDislayed);
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  deleteShop(id: number) {
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette boutique ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.shopService.deleteShop(id).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Boutique supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.allKahpooShop();
  }

  searchShop() {
    this.shopService.getAllShopSearch(this.pageNumber-1, this.pageSize, this.search).subscribe(data => {
      this.shops = data.content;
      this.totalItems = data.totalElements;
      this.initialShops = this.shops;
      this.shopTampons = this.shops;
      // console.log("Liste des boutique crée sur Kahpoo ...")
      // console.log(this.shops)
    })


    // this.shops = this.shopTampons.filter(value =>
    //   value?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
    //   value?.address.toLowerCase().includes(this.search.toLowerCase().trim()) ||
    //   value?.channelName?.toLowerCase().includes(this.search.toLowerCase().trim()) ||
    //   value?.city?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
    //   value?.city?.country?.iso.toLowerCase().includes(this.search.toLowerCase().trim()) ||
    //   value?.sellerId?.firstname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
    //   value?.sellerId?.lastname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
    //   (Number(this.search) === Number(value?.channelNumber)) ||
    //   value?.zone?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
    //   value?.category?.name.toLowerCase().includes(this.search.toLowerCase().trim())
    // )
    // console.log(this.shops);
  }


  ascendingOrderRef: boolean = true;
  sortByReference() {
    this.shops.sort((a, b) => {
      const nameA = a.shopID;
      const nameB = b.shopID;

      if(this.ascendingOrderRef){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderRef = !this.ascendingOrderRef;
  }

  ascendingOrderByShopName: boolean = true;
  sortByShopName(){
    this.shops.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if(this.ascendingOrderByShopName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByShopName = !this.ascendingOrderByShopName;
  }

  ascendingOrderByCreatedDate: boolean = true;
  sortByCreatedDate() {
    this.shops.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      if(this.ascendingOrderByCreatedDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingOrderByCreatedDate = !this.ascendingOrderByCreatedDate;
  }

  ascendingOrderByAdress: boolean = true;
  sortByShopAdress(){
    this.shops.sort((a, b) => {
      const nameA = a.address.toLowerCase();
      const nameB = b.address.toLowerCase();

      if(this.ascendingOrderByAdress){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByAdress = !this.ascendingOrderByAdress;
  }

  ascendingOrderByCountryName: boolean = true;
  sortByShopSellerCountryName(){
    this.shops.sort((a, b) => {
      const nameA = a.city?.country.iso.toLowerCase();
      const nameB = b.city?.country.iso.toLowerCase();

      if(this.ascendingOrderByCountryName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByCountryName = !this.ascendingOrderByCountryName;
  }

  ascendingOrderByCityName: boolean = true;
  sortByShopSellerCityName(){
    this.shops.sort((a, b) => {
      const nameA = a.city?.name.toLowerCase();
      const nameB = b.city?.name.toLowerCase();

      if(this.ascendingOrderByCountryName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByCountryName = !this.ascendingOrderByCountryName;
  }

  ascendingOrderByFirstName: boolean = true;
  sortByShopSellerFirstName(){
    this.shops.sort((a, b) => {
      const nameA = a.sellerId?.firstname.toLowerCase();
      const nameB = b.sellerId?.firstname.toLowerCase();

      if(this.ascendingOrderByFirstName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByFirstName = !this.ascendingOrderByFirstName;
  }

  ascendingOrderPhoneNumber: boolean = true;
  sortByPhoneNumber() {
    this.shops.sort((a, b) => {
      const mobileA = a.mobile;
      const mobileB = b.mobile;
      if(this.ascendingOrderPhoneNumber){
        return mobileA.localeCompare(mobileB);
      }else{
        return mobileB.localeCompare(mobileA);
      }
    })
    this.ascendingOrderPhoneNumber = !this.ascendingOrderPhoneNumber;
  }

  ascendingCategory: boolean = true;
  sortByType() {
    this.shops.sort((a, b) => {
      const nameA = a.category.name;
      const nameB = b.category.name;
      if(this.ascendingCategory){
        return nameA.localeCompare(nameA);
      }else{
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderPhoneNumber = !this.ascendingOrderPhoneNumber;
  }


  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
   // console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  filterByDate() {
    if(this.dateForm.get('beginDate').value=='' || this.dateForm.get('endDate').value==''){
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
    }else{
      const beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
      const endDate = new Date(this.dateForm.get('endDate').value).toISOString();
      // console.log("Date sélectionnée")
      // console.log('beginDate:', beginDate);
      // console.log('endDate:', endDate);
      if(!beginDate || !endDate) {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veuillez renseigner la date de début et la date de fin',
          showConfirmButton: false,
          timer: 3500
        });
        return;
      }else{
        this.shopService.getKahpooShopsByDate(beginDate, endDate,this.pageNumber - 1, this.pageSize).subscribe(data =>{
          this.shops = data.content;
          this.totalItems = data.totalElements;
        });
      }
    }
  }

  filterPostByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;
    if(beginDate == '' || endDate == ''){
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }

    let endDateTrans: any = new Date(endDate);
    endDateTrans.setDate(endDateTrans.getDate() + 1);
    endDateTrans = this.datePipe.transform(endDateTrans,'yyyy-MM-dd');
    //console.log(endDateTrans);

    this.shops = this.initialShops.filter(p => {
      return (p.createdAt >= beginDate) && (p.createdAt <= endDateTrans);
    })
  }

  refresh() {
    this.allKahpooShop();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  getUrlPhoto(photoShop : Shop) {
    this.imageName = photoShop?.photo;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  spsgaredid ?: number;
  spsgaredname ?: string;
  getProductShop(shop : IShop){
    this.spsgaredid = shop?.id;
    this.spsgaredname = shop?.name;
    if(this.spsgaredid != undefined && this.spsgaredname != undefined){
      // const data  = undefined ? '' : JSON.stringify(this.spsgaredid);
      // const data1  = undefined ? '' : JSON.stringify(this.spsgaredname);
      const data = this.spsgaredid === undefined ? '' : JSON.stringify(this.spsgaredid);
      const data1 = this.spsgaredname === undefined ? '' : JSON.stringify(this.spsgaredname);

      const datacryt = this.encryptionService.encryptionAES(data);
      const datacryt1 = this.encryptionService.encryptionAES(data1);
      window.localStorage.setItem('khshshopid!#',datacryt);
      window.localStorage.setItem('khshshopname!#',datacryt1);
      this.sharedSevice.shopIdPartagee = this.spsgaredid;
      this.sharedSevice.shopNamePartagee = this.spsgaredname;
    }
  }

  getServiceShop(shop : IShop){
    this.spsgaredid = shop?.id;
    this.spsgaredname = shop?.name;
    if(this.spsgaredid != undefined && this.spsgaredname != undefined){
      // const data  = undefined ? '' : JSON.stringify(this.spsgaredid);
      // const data1  = undefined ? '' : JSON.stringify(this.spsgaredname);
      const data = this.spsgaredid === undefined ? '' : JSON.stringify(this.spsgaredid);
      const data1 = this.spsgaredname === undefined ? '' : JSON.stringify(this.spsgaredname);

      const datacryt = this.encryptionService.encryptionAES(data);
      const datacryt1 = this.encryptionService.encryptionAES(data1);
      window.localStorage.setItem('khshshopid!#',datacryt);
      window.localStorage.setItem('khshshopname!#',datacryt1);
      this.sharedSevice.shopIdPartagee = this.spsgaredid;
      this.sharedSevice.shopNamePartagee = this.spsgaredname;
    }
  }

}
